import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/header.js';
import Store from 'store/store';

export default class Header extends BaseComp.default {

	renderShare() {
		return [
			this.renderPersistentButton(),
		].concat(super.renderShare());
	}

	async triggerActionButton(homeEntVisible) {
		let actionData = this.getCurrentActionBtnAction(homeEntVisible);
		Store.emit('POP_SHOWTIMES_BTN_ACTION');
		try {
			if (typeof actionData.action === 'function') {
				if (actionData.tag === 'collapseTheater') {
					const currentUrl = new URL(window.location);
					currentUrl.search = '';
					const cleanUrl = currentUrl.toString();
					window.history.pushState({}, '', cleanUrl);
				}
				await actionData.action();
			} else if (typeof actionData.action === 'string') {
				Store.emit(actionData.action);
			}
		} catch (err) {}
	}

	renderPersistentButton() {
		const base = super.renderPersistentButton();
		const method = (e) => {
			this.onClick(e);
			let format = Store.get().selectedFormat;
			if (!format) return;
			if (format === 'DOLBY') format = 'Dolby Cinema';
			if (format === 'PLF') format = ['PLF', '4DX', 'D-BOX'];
			Store.emit('FILTER_SET', 'format', format);
		};
		base.children[0].attributes.onClickCapture = method;
		return base;
	}
}
